import { Typography } from "@mui/material";
import { useContext } from "react";
import { FirmaElectronicaContext } from "../context/firmaElectronicaContext";
import { ModalCertificadosGuardados } from "../modalCertificadosGuardados/modalCertificadosGuardados";

export const LinkSaveCertificado = () => {
  const { handleClickShowCerKeySave } = useContext(FirmaElectronicaContext);

  return (
    <>
      <Typography
        className="underline cursor-pointer firmasSaved"
        variant="subtitle1"
        onClick={() => handleClickShowCerKeySave(true)}
      >
        Certificados guardados
      </Typography>
      <ModalCertificadosGuardados />
    </>
  );
};
